import React, { useEffect, useState } from "react";
import Footer from "../../../Kryzen Alpha App/Components//Footer/footer";
import performRequest from "../../../Kryzen Alpha App/api/request";
import { Toast } from "../../../Kryzen Alpha App/CustomComponent/toast";
import { useDispatch, useSelector } from "react-redux";
import DynamicFilterInput from "../../../Kryzen Alpha App/Components/layouts/filter.inpit";
import DynamicFilterSelect from "../../../Kryzen Alpha App/Components/layouts/filter.select";
import getFilteredURL from "../../../Kryzen Alpha App/Components/Functions/filters.getUrl";
import Pagination from "../../Components/layouts/pagination";
import { PiPottedPlantDuotone } from "react-icons/pi";
import CropUpdateTable from "./Crop Updates/crop_update_table";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import LoadingPage from "../../Components/layouts/loading";
import CustomViedoCard from "../../CustomComponent/custom_viedo_card";
import { useNavigate, useSearchParams } from "react-router-dom";
import { setCropPage } from "../../redux/Pagination/pagination";

const CropUpdate = () => {
  const [loading, setLoading] = useState(false);
  const [accessLoaded, setAccessLoaded] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const dispatch = useDispatch();
  const page = useSelector((state) => state.pagination.cropPage);
  // const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [farmName, setFarmName] = useState();
  const store = useSelector((store) => store.login.user);
  const [filters, setFilters] = useState({
    startdate: "",
    enddate: "",
    farmName: "",
    archieveData: 0,
  });
  const [data, setData] = useState([]);
  const [themeSet, setThemeSet] = useState("");
  const [searchParams] = useSearchParams();
  const showArchived = filters.archieveData === 1;
  const theme = searchParams.get("theme");

  useEffect(() => {
    setThemeSet(theme);
  }, [theme]);
  const [checkClientAccess, setCheckClientAccess] = useState({
    workOrder: false,
    isHandOverCompleted: false,
    isClient: store?.Role == process.env.REACT_APP_ROLE_CLIENT,
  });
  const navigate = useNavigate();

  useEffect(() => {
    if (
      store.Role !== process.env.REACT_APP_ROLE_ADMIN_S &&
      store.Role !== process.env.REACT_APP_ROLE_ADMIN &&
      store.Role !== process.env.REACT_APP_ROLE_AGRONOMIST
    ) {
      setLoading(true);
      setAccessLoaded(false);

      performRequest(
        "GET",
        getFilteredURL("/projectTracking/getProjectTracking", 1)
      )
        .then((res) => {
          if (res.status === 200) {
            if (res?.data?.clientHandover?.handOverCertificate) {
              let access = {
                isHandOverCompleted: false,
                workOrder: false,
                isClient: false,
              };
              if (res?.data?.clientHandover?.handOverCertificate) {
                access.isHandOverCompleted = true;
              }
              if (res?.data?.projectTrackingData?.[0]?.workOrderUpload) {
                access.workOrder = true;
              }
              if (store?.Role == process.env.REACT_APP_ROLE_CLIENT) {
                access.isClient = true;
              }
              setAccessLoaded(true); // ✅ important
              setCheckClientAccess(access);
            } else {
              // Toast(
              //   "error",
              //   "Client handover not done yet, please connect with team!"
              // );
            }
          } else {
            Toast("error", "Error while getting Details!");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
    }
  }, [refresh]);

  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      getFilteredURL("/cropUpdate/getCropUpdate/", page, filters)
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setTotalPages(Math.ceil(res.data?.cropUpdateCount / 50));
        } else {
          Toast("error", "Error while getting Data!");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [refresh, page]);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", "/clientProject/getCpNameForClients/")
      .then((res) => {
        if (res.status === 200) {
          setFarmName(res?.data?.clientProjectsData);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [refresh, page]);

  const navigateTocreateBatch = () => {
    if (
      checkClientAccess?.isClient &&
      !checkClientAccess?.isHandOverCompleted
    ) {
      data?.cropUpdate?.length > 0
        ? Toast(
            "error",
            "Your handover process is not completed yet. So, you cannot create crop schedule till that. Please contact Kryzen support team for more details."
          )
        : navigate("/farm-crop-schedule/new");
    } else {
      navigate("/farm-crop-schedule/new");
    }
  };
  if (loading) {
    return <LoadingPage />;
  }
  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <PiPottedPlantDuotone
                    className="fs-2  me-1"
                    style={{ color: "green" }}
                  />{" "}
                  Crop Schedule
                </h2>
                <h4 className="text-muted">
                  {/* <StepRoutes /> */} Track & manage your crops.
                </h4>
              </div>
              <div className="col-md-4 d-none d-sm-block">
                <div className="btn-list justify-content-end">
                  <button
                    className="btn btn-primary"
                    onClick={() => navigateTocreateBatch()}
                  >
                    {" "}
                    <PiPottedPlantDuotone className="fs-3 me-2" />
                    CREATE CROP SCHEDULE
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-2">
                <div
                  id="faq-1"
                  className="accordion"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <div>
                    <div className="accordion-header m-0" role="tab">
                      <button
                        className="accordion-button fs-3 d-md-none p-0"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq-1-1"
                      >
                        <h3 className="m-1">Filter result</h3>
                      </button>
                    </div>

                    <div
                      id="faq-1-1"
                      className="accordion-collapse collapse d-md-none"
                      role="tabpanel"
                      data-bs-parent="#faq-1"
                    >
                      <div
                        className={`accordion-body pt-0 ${
                          themeSet === "dark" ? "text-light" : ""
                        }`}
                      >
                        <div className="row">
                          <div className="col-12">
                            <DynamicFilterInput
                              label="Start Date:"
                              value={filters.startdate}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  startdate: e.target.value,
                                })
                              }
                              type="date"
                            />
                          </div>
                          <div className="col-12">
                            <DynamicFilterInput
                              label="End Date:"
                              value={filters.enddate}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  enddate: e.target.value,
                                })
                              }
                              type="date"
                            />
                          </div>
                          {(store.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                            store.Role === process.env.REACT_APP_ROLE_ADMIN ||
                            store.Role ===
                              process.env.REACT_APP_ROLE_AGRONOMIST) && (
                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Search farm name:"
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    farmName: e.target.value,
                                  })
                                }
                                value={filters.farmName}
                              >
                                <option value="">select all</option>

                                {farmName &&
                                  farmName?.map((state, index) => (
                                    <option
                                      key={index}
                                      value={state?.clientName}
                                    >
                                      {state?.clientName}
                                    </option>
                                  ))}
                              </DynamicFilterSelect>
                            </div>
                          )}

                          <div className="col-12">
                            <div className="row mt-2">
                              <div className="col-6">
                                <button
                                  onClick={() => setRefresh(!refresh)}
                                  className="btn btn-success w-100"
                                >
                                  Apply Filter
                                </button>
                              </div>
                              <div className="col-6">
                                <button
                                  onClick={() => {
                                    setFilters({
                                      startdate: "",
                                      enddate: "",
                                      farmName: "",
                                    });
                                    setRefresh(!refresh);
                                  }}
                                  className="btn btn-secondary w-100"
                                >
                                  Reset Filter
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className={`accordion-body d-none d-md-block ${
                        themeSet === "dark" ? "text-light" : ""
                      }`}
                    >
                      <div className="row">
                        <h3>Filter result</h3>
                        <div className="col-12">
                          <DynamicFilterInput
                            label="Start Date:"
                            value={filters.startdate}
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                startdate: e.target.value,
                              })
                            }
                            type="date"
                          />
                        </div>
                        <div className="col-12">
                          <DynamicFilterInput
                            label="End Date:"
                            value={filters.enddate}
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                enddate: e.target.value,
                              })
                            }
                            type="date"
                          />
                        </div>
                        {(store.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                          store.Role === process.env.REACT_APP_ROLE_ADMIN ||
                          store.Role ===
                            process.env.REACT_APP_ROLE_AGRONOMIST) && (
                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Search farm name:"
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  farmName: e.target.value,
                                })
                              }
                              value={filters.farmName}
                            >
                              <option value="">select all</option>

                              {farmName &&
                                farmName?.map((state, index) => (
                                  <option key={index} value={state?.clientName}>
                                    {state?.clientName}
                                  </option>
                                ))}
                            </DynamicFilterSelect>
                          </div>
                        )}

                        <div className="col-12">
                          <div className="row mt-2">
                            <div className="col-6">
                              <button
                                onClick={() => setRefresh(!refresh)}
                                className="btn btn-success w-100"
                              >
                                Apply Filter
                              </button>
                            </div>
                            <div className="col-6">
                              <button
                                onClick={() => {
                                  setFilters({
                                    startdate: "",
                                    enddate: "",
                                    farmName: "",
                                  });
                                  setRefresh(!refresh);
                                }}
                                className="btn btn-secondary w-100"
                              >
                                Reset Filter
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-3 mb-3">
                {!showArchived && (
                  <button
                    onClick={() => {
                      setFilters((prev) => ({ ...prev, archieveData: 1 }));
                      dispatch(setCropPage(1));
                      setRefresh((r) => !r);
                    }}
                    className="btn btn-outline btn-danger w-100"
                  >
                    Archived Schedule
                  </button>
                )}

                {showArchived && (
                  <button
                    onClick={() => {
                      setFilters((prev) => ({ ...prev, archieveData: 0 }));
                      dispatch(setCropPage(1));
                      setRefresh((r) => !r);
                    }}
                    className="btn btn-outline btn-success w-100"
                  >
                    Active Schedule
                  </button>
                )}
              </div>
              <div className="d-none d-lg-block d-md-block">
                <CustomViedoCard
                  viedoLink={"https://www.youtube.com/embed/XDveD9BfbkY"}
                  id={"model-viedo"}
                  name={"crop schedule"}
                ></CustomViedoCard>
              </div>
            </div>
            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                {
                  <CropUpdateTable
                    data={data?.cropUpdate}
                    currentPage={page}
                    itemsPerPage={50}
                    showArchived={showArchived}
                    onActionComplete={() => setRefresh((r) => !r)}
                  />
                }

                <div className="btn-list justify-content-center">
                  <div className="d-lg-none d-md-none mt-3 mb-3">
                    <button
                      onClick={() => navigateTocreateBatch()}
                      className="btn btn-primary"
                    >
                      {" "}
                      <PiPottedPlantDuotone className="fs-3 me-2" /> CREATE CROP
                      SCHEDULE
                    </button>
                  </div>
                </div>

                <Pagination
                  page={page}
                  setPage={(newPage) => dispatch(setCropPage(newPage))}
                  totalPages={totalPages}
                  pageDatalength={data?.cropUpdate?.length}
                  showPage={showPage}
                  setShowPage={setShowPage}
                />
              </div>
            </div>
          </div>
          <div className="d-block d-md-none d-lg-none">
            <CustomViedoCard
              viedoLink={"https://www.youtube.com/embed/XDveD9BfbkY"}
              id={"model-viedo2"}
              name={"crop schedule"}
            ></CustomViedoCard>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default CropUpdate;
